import { render } from "./ClubDashboardLayout.vue?vue&type=template&id=65a0cf33&scoped=true"
import script from "./ClubDashboardLayout.vue?vue&type=script&lang=js"
export * from "./ClubDashboardLayout.vue?vue&type=script&lang=js"

import "./ClubDashboardLayout.vue?vue&type=style&index=0&id=65a0cf33&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65a0cf33"]])

export default __exports__